/* ============================================================
   AURA — aura-cart.js
   LV-style Added to Cart popup + cart enhancements
   Runs AFTER strk.js, patches STRK.addToCart
   ============================================================ */
(function() {
  'use strict';

  var STRK = window.STRK || {};

  /* ── LV POPUP ── */
  var capOverlay   = document.getElementById('cap-overlay');
  var capSheet     = document.getElementById('cap-sheet');
  var capClose     = document.getElementById('cap-close');
  var capViewCart  = document.getElementById('cap-view-cart');
  var capContinue  = document.getElementById('cap-continue-shop');
  var capImg       = document.getElementById('cap-img');
  var capName      = document.getElementById('cap-name');
  var capVar       = document.getElementById('cap-var');
  var capPrice     = document.getElementById('cap-price');

  var cartOverlay  = document.getElementById('cart-overlay');
  var cartDrawer   = document.getElementById('cart-drawer');

  function showPopup(item) {
    if (!capSheet) return;
    if (capImg && item.image)          capImg.src = item.image;
    if (capName)                        capName.textContent  = item.product_title || item.title || '';
    if (capVar && item.variant_title && item.variant_title !== 'Default Title')
                                        capVar.textContent   = item.variant_title;
    if (capPrice)                       capPrice.textContent = formatMoney(item.final_price || item.price || 0);
    capSheet.classList.add('open');
    if (capOverlay) capOverlay.classList.add('open');
  }

  function hidePopup() {
    if (capSheet)   capSheet.classList.remove('open');
    if (capOverlay) capOverlay.classList.remove('open');
  }

  function openDrawer() {
    if (cartDrawer)  cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  if (capClose)    capClose.addEventListener('click',    hidePopup);
  if (capContinue) capContinue.addEventListener('click', hidePopup);
  if (capOverlay)  capOverlay.addEventListener('click',  hidePopup);
  if (capViewCart) capViewCart.addEventListener('click', function() {
    hidePopup();
    if (STRK.cartType === 'drawer') {
      openDrawer();
    } else {
      window.location.href = '/cart';
    }
  });

  function formatMoney(cents) {
    var sym = (window.STRK && window.STRK.shopCurrency) || '$';
    return sym + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateCartCount(count) {
    var badge = document.getElementById('cart-count');
    if (badge) {
      badge.textContent = count;
      badge.classList.add('bump');
      setTimeout(function() { badge.classList.remove('bump'); }, 400);
    }
  }

  /* ── PATCH PRODUCT FORM SUBMIT ── */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    /* Remove strk.js listener by cloning the form node */
    var newForm = productForm.cloneNode(true);
    productForm.parentNode.replaceChild(newForm, productForm);

    newForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = newForm.querySelector('#variant-id') || newForm.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;

      var atcBtn   = document.getElementById('atc-btn');
      var origText = atcBtn ? atcBtn.textContent : 'Add to Cart';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantInput.value, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          updateCartCount(cart.item_count);
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = origText; }
          if (STRK.cartLvPopup) {
            showPopup(item);
          } else if (STRK.cartType === 'drawer') {
            openDrawer();
          } else {
            window.location.href = '/cart';
          }
        });
      })
      .catch(function(err) {
        console.error(err);
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = origText; }
      });
    });
  }

  /* ── PATCH STRK.addToCart (product grid quick add) ── */
  var _origAddToCart = STRK.addToCart;
  STRK.addToCart = function(btn) {
    if (btn.classList.contains('so') || btn.disabled) return;
    var variantId    = btn.dataset.variantId;
    var productTitle = btn.dataset.productTitle;
    var productPrice = btn.dataset.productPrice;
    var productImage = btn.dataset.productImage;
    if (!variantId) return;

    var tray = btn.closest('.stray');
    var orig = tray ? tray.innerHTML : '';
    if (tray) tray.innerHTML = '<div style="padding:10px 0;text-align:center;font-family:var(--body);font-size:12px;font-weight:500;letter-spacing:.04em;">Added ✓</div>';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateCartCount(cart.item_count);
        if (tray) setTimeout(function() { tray.innerHTML = orig; }, 1600);
        if (STRK.cartLvPopup) {
          showPopup(item);
        } else if (STRK.cartType === 'drawer') {
          var drawerBody  = document.getElementById('drawer-body');
          var drawerTotal = document.getElementById('drawer-subtotal-amount');
          if (drawerBody) {
            var sl = (btn.textContent.trim() === 'Add to cart') ? 'One Size' : btn.textContent.trim();
            drawerBody.innerHTML =
              '<div class="drawer-item">' +
              (productImage ? '<img class="drawer-item-img" src="' + productImage + '" alt="">' : '') +
              '<div><p class="drawer-item-name">' + productTitle + '</p>' +
              '<p class="drawer-item-var">Size: ' + sl + '</p>' +
              '<p class="drawer-item-price">' + productPrice + '</p></div></div>';
          }
          if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
          var co = document.getElementById('cart-overlay');
          var cd = document.getElementById('cart-drawer');
          if (co) co.classList.add('open');
          if (cd) cd.classList.add('open');
          document.body.style.overflow = 'hidden';
        } else {
          window.location.href = '/cart';
        }
      });
    })
    .catch(function(err) {
      console.error('Cart error:', err);
      if (tray) tray.innerHTML = orig;
    });
  };

})();
